<template>
  <div class="login flex align-center justify-center" @touchmove.prevent   @scroll.stop.prevent>
    <div class="login-main flex-column justify-space-between">
      <div class="flex justify-end p-10">
        <img src="/images/guanbi.png" alt="" @click="onClose" class="cursor">
      </div>
      <div class="flex-column align-center justify-center mb-10">
        <div class="font-22 color-292a2e mb-8 font-yahei">用户登录</div>
        <div class="color-ff5555 font-12 mb-54">请先登录后再进行后续操作</div>
        <div class="flex align-center w-305 border-b mb-28">
          <img src="/images/dengluzhanghao.png" alt="">
          <span class="color-292a2e font-16 ml-10">账号</span>
          <span class="line"></span>
          <el-input v-model="username" placeholder="请输入手机号" class="flex-1" size="mini"></el-input>
        </div>
        <div class="flex align-center w-305 border-b mb-28">
          <img src="/images/denglumima.png" alt="">
          <span class="color-292a2e font-16 ml-10">密码</span>
          <span class="line"></span>
          <el-input v-model="password" placeholder="请输入密码" show-password class="flex-1" size="mini"></el-input>
        </div>
        <div class="btn-40 bg-292a2e color-ff w-305 radius-round mb-28" @click="toLogin">登录</div>
        <div class="flex align-center justify-space-between w-305">
          <!-- <div class="font-16 color-292a2e cursor">忘记密码</div> -->
          <div class="font-16 color-292a2e cursor"></div>
          <div class="font-16 color-292a2e cursor flex align-center" @click="toRegister">去注册<img src="/images/jinruxiangqing.png" alt="" class="ml-10"></div>
        </div>
      </div>
      <div class="flex justify-end mr-30 mb-30">
        <img src="/images/dengluhoutai.png" alt="" class="shadow cursor">
      </div>
    </div>
  </div>
</template>

<script>
import axiosx from 'axios'
export default {
  name: "Login",
  components: {},
  data () {
    return {
      username:'',
      password: ''
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    toLogin () {
      if (!this.username) {
        this.$message({
            type: 'warning',
            message: '请填写账号!'
          })
      } else if (!this.password) {
        this.$message({
            type: 'warning',
            message: '请填写密码!'
          })
      } else {
        let params = {
          username: this.username,
          password: this.password
        }
        this.axios.post('common/customerLogin',this.qs.stringify(params)).then(res => {
				if (res.data.success) {
          console.log(res.data)
          this.$message.success(res.data.message)
          this.$store.dispatch('setUser', res.data.data)
          this.$store.dispatch('setToken', res.data.data.token)
          this.$store.dispatch('setLogin', false);
          this.$router.go(0)
				} else {
					this.$message.error(res.data.message)
				}
			})
      }
    },
    toRegister () {
      this.$parent.isRegister = true
       this.$store.dispatch('setLogin', false);
      // console.log(this.$parent.isRegister)
    },
    onClose () {
      this.$store.dispatch('setLogin', false);
    },
  }
};
</script>

<style lang="scss" scoped>
  .login{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .login-main{
    width: 1105px;
    height: 478px;
    background: #fff url("/images/denglubg.png") no-repeat center bottom;
    border-radius: 4px;
  }
  .w-305{
    width: 305px;
  }
  .border-b{
    border-bottom: 1px solid #e9e9e9;
    padding-bottom: 6px;
  }
  .line{
    width: 1px;
    height: 18px;
    background: #e9e9e9;
    margin: 0 12px;
  }
  .shadow {
    border-radius: 30px;
    box-shadow: 0px 0px 30px 0px 
		rgba(41, 42, 46, 0.07);
  }
  ::v-deep{
    .el-input__inner{
      border: 0;
      background: transparent;
      font-size: 16px;
      padding: 0;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
      border: 0;
    }
  }
</style>
